import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../imageWithBasePath'
import { all_routes } from '../../../feature-module/router/all_routes'

const Footer = () => {
  const offices = [
    {
      city: "Coimbatore",
      address: "965, 3rd Floor Lakshmi Mills Junction Avinashi Road, Near by ZONE HOTEL, Coimbatore.",
      address2: "Tamil Nadu – 641037."
    },
    {
      city: "Thanjavur",
      address: "5/3, 1st Floor, Opp to New Bus Stand, Trichy Road, Thanjavur.",
      address2: "Tamil Nadu  – 613005."
    },
    {
      city: "Madurai",
      address: "141a, 142, 2nd Floor, Alagar Kovil Main Road, Tallagulam, Madurai.",
      address2: "Tamil Nadu  – 625002."
    },
    {
      city: "Namakkal",
      address: "193/4, 4th Floor, PVK Complex, Salem Road, Namakkal.",
      address2: "Tamil Nadu  – 637001."
    }
  ];

  return (
    <>
      {/* Footer */}
      <footer className="footer">

        <div className="footer-bg">
          {/* <ImageWithBasePath
            src="assets/img/bg/footer-bg-01.png"
            className="footer-bg-1"
            alt=""
          /> */}
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-02.png"
            className="footer-bg-2"
            alt=""
          />
        </div>
        <div className="footer-top">
          <div className="container">
            <div className="row row-gap-4">
              <div className="col-lg-4">
                <div className="footer-about">
                  <div className="footer-logo">
                    <ImageWithBasePath src="assets/img/palanisvglogo.svg" alt="" />
                  </div>
                  <p>
                    <b>

                      Empowering Learning, Everywhere.
                    </b>
                    <br />


                    A smart platform built to help {
                      " "
                    }
                    <b>
                      organizations, educators, and learners
                    </b>{
                      " "
                    }

                    seamlessly manage, deliver, and track learning journeys with ease.
                    <b>
                      <br />

                      Learn Smarter. Teach Better. Grow Together.
                    </b>

                  </p>
                  {/* <div className="d-flex align-items-center">
                    <Link to="#" className="me-2">
                      <ImageWithBasePath src="assets/img/icon/appstore.svg" alt="" />
                    </Link>
                    <Link to="#">
                      <ImageWithBasePath src="assets/img/icon/googleplay.svg" alt="" />
                    </Link>
                  </div> */}
                </div>
                <div className="footer-contact-info">
                  <h5 className="footer-title text-[#1D1753]">Contact</h5>


                  <div className="footer-address d-flex align-items-center">
                    <ImageWithBasePath
                      src="assets/img/icon/icon-19.svg"
                      alt="Img"
                      className="img-fluid me-2"
                    />
                    <p>admission@palaniveloverseas.com</p>
                  </div>
                  <div className="footer-address d-flex align-items-center">
                    <ImageWithBasePath
                      src="assets/img/icon/icon-21.svg"
                      alt="Img"
                      className="img-fluid me-2"
                    />
                    <p>+91 78737 33333</p>
                  </div>
                </div>

              </div>
              <div className="col-lg-8">
                <div className="row row-gap-4">
                  <div className="col-lg-3">
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title text-[#1D1753]">Countries</h5>
                      <ul>
                        <li>
                          <Link to="/study_destination_country/686fb5ec0f82d03dc403de29">Canada</Link>
                        </li>
                        <li>
                          <Link to="/study_destination_country/6874b5e41fb234d142f9d406">Australia</Link>
                        </li> <li>
                          <Link to="/study_destination_country/6878ba49fc050438dd8b4de8">Ireland</Link>
                        </li> <li>
                          <Link to="/study_destination_country/6878db6fb6d1934d37806c85">UK</Link>
                        </li> <li>
                          <Link to="/study_destination_country/6878e90cb6d1934d37806e86">US</Link>
                        </li>
                        <li>
                          <Link to="/study_destination_country/68832ef3990de82002955b03">Singapore</Link>
                        </li>
                        <li>
                          <Link to="/study_destination_country/68971545c7c75fef77006c96">New Zealand</Link>
                        </li>
                        <li>
                          <Link to="/study_destination_country/6897333cc7c75fef770072bd">Dubai</Link>
                        </li>
                        <li>
                          <Link to="/study_destination_country/68973349c7c75fef770072c1">EU</Link>
                        </li>
                        {/* <li>
                          <Link to={all_routes.login}>Login</Link>
                        </li>
                        <li>
                          <Link to={all_routes.register}>Register</Link>
                        </li>
                        <li>
                          <Link to={all_routes.courseList}>Booking</Link>
                        </li>
                        <li>
                          <Link to={all_routes.studentDashboard}>Students Dashboard</Link>
                        </li> */}
                      </ul>
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title text-[#1D1753]">Student Essentials</h5>
                      <ul>
                        <li>
                          <Link to="/study_health_cover">Education Loan</Link>
                        </li>
                        <li>
                          <Link to="/study_health_cover">Student Health Cover</Link>
                        </li>

                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title text-[#1D1753]">Useful Links</h5>
                      <ul>
                        <li>
                          <Link to="/course_advice">How to find a course</Link>
                        </li>
                        <li>
                          <Link to="/study_abroad_courses">Study Abroad Courses</Link>
                        </li>
                        <li>
                          <Link to="/scholarships">How to find Scholarships</Link>
                        </li>
                        {/* <li>
                          <Link to="#">Student Essentials</Link>
                        </li> */}
                        {/* <li>
                          <Link to="#">
                            Instructor Dashboard
                          </Link>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="footer-widget footer-contact">
                      {/* <h5 className="footer-title text-[#1D1753]">Newsletter</h5>
                      <div className="subscribe-input">
                        <form action="#">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter your Email Address"
                          />
                          <button
                            type="submit"
                            className="btn btn-primary btn-sm inline-flex align-items-center"
                          >
                            <i className="isax isax-send-2 me-1" />
                            Subscribe
                          </button>
                        </form>
                      </div> */}



                      {/* <div className="footer-contact-info">
                        <h5 className="footer-title text-[#1D1753]">Contact</h5>

                       
                        <div className="footer-address d-flex align-items-center">
                          <ImageWithBasePath
                            src="assets/img/icon/icon-19.svg"
                            alt="Img"
                            className="img-fluid me-2"
                          />
                          <p>admission@palaniveloverseas.com</p>
                        </div>
                        <div className="footer-address d-flex align-items-center">
                          <ImageWithBasePath
                            src="assets/img/icon/icon-21.svg"
                            alt="Img"
                            className="img-fluid me-2"
                          />
                          <p>+91 78737 33333</p>
                        </div>
                      </div> */}



                    </div>
                  </div>
                </div>
                <div className='row'>
                  <h5 className="footer-title text-[#1D1753] pb-1">Our Branches</h5>
                  <div className="footer-contact-info container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1 mb-4">

                    {
                      offices?.map((item, index) => (
                        <div className="footer-address d-flex align-items-start">
                          {/* <ImageWithBasePath
                src="assets/img/icon/icon-20.svg"
                alt="Img"
                className="img-fluid me-2"
              /> */}
                          <div className='flex flex-col t'>
                            <h6 className="footer-title text-[#1D1753] pb-1">{item?.city}</h6>

                            <p className='p-0 m-0'>
                              {item?.address}
                            </p>
                            <p className='p-0 m-0'>
                              {item?.address2}
                            </p>
                          </div>
                        </div>))
                    }


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="row row-gap-2">
              <div className="col-md-8">
                <div className="text-center text-md-start">
                  <p className="text-white">
                    Copyright © 2025 <span className='text-[#EA1D2A] uppercase'>Palanivel overseas</span> All rights reserved.
                    {/* Developed by PROPLUS LOGICS */}
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div>
                  <ul className="d-flex align-items-center justify-content-center justify-content-md-end footer-link">
                    <li>
                      <Link to="#">Terms &amp; Conditions</Link>
                    </li>
                    <li>
                      <Link to="#">Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* /Footer */}
    </>


  )
}

export default Footer